import { createSlice } from '@reduxjs/toolkit'

// ----------------------------------------------------------------------

export const initialState: {
  contractType: any
  businessUnitActionContexts: any[]
  isLoading: boolean
  error: string
} = {
  contractType: null,
  businessUnitActionContexts: [],
  isLoading: true,
  error: ''
}

const slice = createSlice({
  name: 'createPayload',
  initialState,
  reducers: {
    // START LOADING
    startCreatePayloadLoading(state) {
      state.isLoading = true
    },

    // HAS ERROR
    hasCreatePayloadError(state, action) {
      state.isLoading = false
      state.error = action.payload
    },

    // Fetch Create Payload Guarantee
    setGuaranteeRequestPayload(state, action) {
      state.isLoading = false
      state.businessUnitActionContexts = action?.payload ? [...action.payload] : []
      state.contractType = action?.payload[0]?.contractType
    },

    // Clear payload
    clearGuaranteePayload(state) {
      state.isLoading = false
      state.businessUnitActionContexts = []
      state.contractType = null
      state.error = ''
    }
  }
})

// Reducer
export default slice.reducer

// ----------------------------------------------------------------------
export const { setGuaranteeRequestPayload, hasCreatePayloadError, startCreatePayloadLoading, clearGuaranteePayload } =
  slice.actions

export function getCreatePayload(data: Response, status, dispatch) {
  dispatch(slice.actions.startCreatePayloadLoading())
  try {
    if (status.status === 'OK') {
      dispatch(slice.actions.setGuaranteeRequestPayload(data))
    } else {
      dispatch(slice.actions.hasCreatePayloadError('Error Occurred while fetching create Payload'))
    }
  } catch (error) {
    dispatch(slice.actions.hasCreatePayloadError(error))
  }
}
